import Vue from 'vue';
export default Vue.extend({
    name: 'claim-table',
    props: {
        border: {
            type: Boolean,
            default: false,
        },
        tableConfig: {
            type: Array,
            default: [],
        },
        sortChange: {
            type: Function,
            default: null,
            required: false,
        },
        callbackFunc: {
            type: Function,
            default: null,
        },
    },
    data: function () {
        return {
            loading: false,
            dataList: [],
            pageInfo: {
                pageSize: 10,
                pageNo: 1,
                totalItemCount: 0,
            },
        };
    },
    methods: {
        searchData: function (val) {
            if (this.callbackFunc) {
                this.callbackFunc(val);
            }
        },
        sortChangeFunc: function (column, prop, order) {
            if (this.sortChange) {
                this.sortChange(column, prop, order);
            }
        },
        currentChange: function (val) {
            this.searchData(val);
        },
        fillTableData: function (dataset, page) {
            this.dataList = dataset;
            this.pageInfo = page;
        },
        sizeChange: function (val) {
            this.searchData(val);
        },
    },
});
